<template>
    <div>
        <b-form-group :label="$t('form.label.title')">
            <b-form-input
                v-model="$v.form.title.$model"
                :state="checkFieldState($v.form.title)"
                :placeholder="$t('form.placeholder.writeHere')"
            />
        </b-form-group>
        <b-form-group :label="$t('form.label.description')">
            <b-form-textarea
                v-model="$v.form.description.$model"
                :state="checkFieldState($v.form.description)"
                :placeholder="$t('form.placeholder.writeHere')"
            />
        </b-form-group>
        <b-button
            size="sm"
            variant="primary"
            class="float-right"
            :disabled="isSubmitting"
            @click="onClickSubmit"
        >
            {{ $t('form.button.send') }}</b-button
        >
    </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
export default {
    props: {
        data: Object,
        isSubmitting: Boolean,
    },
    mixins: [validationMixin],
    validations: {
        form: {
            title: { required },
            description: {},
        },
    },
    data() {
        return {
            form: {
                title: null,
                description: null,
            },
        }
    },
    mounted() {
        if (this.data) {
            this.form = { ...this.data }
        }
    },
    methods: {
        onClickSubmit() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                return
            }

            this.$emit('submit', this.$v.form.$model)
        },
        checkFieldState(field) {
            return field.$dirty ? !field.$invalid : null
        },
    },
}
</script>
